import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import Toggle from 'components/ReusableComponents/Toggle'
import { componentModes, PACKAGE_OPTIONS } from 'features/NewHotelDialog/constants'
import { checkDate } from 'features/NewHotelDialog/helpers'
import moment from 'moment'
import { useState } from 'react'
import DatePicker from 'react-datepicker'
import CreatableSelect from 'react-select/creatable'
import { useToasts } from 'react-toast-notifications'

import styles from '../Services.module.scss'
import { handleChangeReferrer, handleDiscountChange } from './helpers'
import { usePaymentPeriodData } from './usePaymentPeriodData'

const EditPaymentPeriodDialog = ({
  onSave,
  onClose,
  mode = 'paymentPeriod',
  nearestStartDate
}) => {
  const { addToast } = useToasts()

  const {
    paymentPeriodData,
    handleFormChange,
    setPaymentPeriodData,
    referrers,
    salesAgents,
    isPreOnboardingCompleted,
    isLoading,
    handleSave
  } = usePaymentPeriodData({ mode, onSave, addToast, nearestStartDate })

  const {
    period,
    discount,
    monthlyRate,
    hasPremiumSupport,
    premiumSupportFee,
    selectedPackage,
    salesPersonUserId,
    serviceStartDate
  } = paymentPeriodData

  const [minServiceStartDate] = useState(serviceStartDate)

  const renderMonthContent = (month, shortMonth, longMonth, day) => {
    const fullYear = new Date(day).getFullYear()
    const tooltipText = `Tooltip for month: ${longMonth} ${fullYear}`

    return <span title={tooltipText}>lelele {shortMonth}</span>
  }

  return (
    <ConfirmationDialog
      title={
        mode === componentModes.switchToPrepay
          ? 'Switch to prepay'
          : 'Edit following payment periods'
      }
      theme="blacklist"
      onClose={onClose}
      onConfirm={handleSave}
      isButtonDisabled={!period || isLoading}
      isRejectButtonDisabled={isLoading}
      positiveMessage={isLoading ? <LoadingIndicator inline /> : 'Update'}
      negativeMessage="Cancel"
      contentPadding={0}
    >
      <div className={styles.updateInputsHolder}>
        {mode === componentModes.switchToPrepay && (
          <div className={styles.formRow}>
            <Dropdown
              label="Sales agent"
              defaultVal={'Select sales agent'}
              options={salesAgents?.reduce(
                (acc, curr) => ({ ...acc, [curr.id]: curr.fullName }),
                {}
              )}
              onChange={handleFormChange}
              name="salesPersonUserId"
              value={salesPersonUserId}
            />
            <label className={styles.creatableSelectContainer}>
              <div className={styles.creatableSelectLabel}>Select Referrer</div>
              <CreatableSelect
                onChange={(newValue, actionMeta) =>
                  handleChangeReferrer(newValue, actionMeta, setPaymentPeriodData)
                }
                options={referrers}
              />
            </label>
          </div>
        )}
        <Dropdown
          type="select"
          label="Period"
          options={{
            monthly: 'Monthly',
            semiAnnual: 'Semi-Annual',
            quarterly: 'Quarterly',
            annual: 'Annual'
          }}
          value={period}
          defaultVal="Select period"
          onChange={handleFormChange}
          name="period"
        />

        {console.log({ minServiceStartDate })}
        {isPreOnboardingCompleted && (
          <>
            <h4 className={styles.label}>Next payment period start</h4>
            <DatePicker
              selected={new Date(serviceStartDate)}
              renderMonthContent={renderMonthContent}
              showMonthYearPicker
              dateFormat="MM/yyyy"
              minDate={
                moment().isAfter(minServiceStartDate)
                  ? new Date()
                  : new Date(minServiceStartDate)
              }
              onChange={date => setPaymentPeriodData({ serviceStartDate: date })}
              className={styles.datePickerInput}
            />
          </>
        )}
        {!isPreOnboardingCompleted && (
          <TextInput
            type="date"
            label="Service start date"
            className={styles.input}
            min={moment().add(1, 'days').format('YYYY-MM-DD')}
            name="serviceStartDate"
            value={serviceStartDate}
            onChange={e => checkDate(e.target.value, addToast, setPaymentPeriodData)}
            dateFormat="yyyy-MM-dd"
          />
        )}

        <div className={styles.packageSelection}>
          <h4 className={styles.sectionTitle}>Package selection</h4>
          {Object.entries(PACKAGE_OPTIONS).map(([value, option]) => (
            <div
              key={option.id}
              className={styles.packageOption}
              onClick={() => setPaymentPeriodData({ selectedPackage: value })}
            >
              <input
                type="radio"
                id={option.id}
                name="selectedPackage"
                value={value}
                checked={selectedPackage === value}
                onChange={e => setPaymentPeriodData({ selectedPackage: e.target.value })}
              />
              <label htmlFor={option.id}>{option.label}</label>
            </div>
          ))}
        </div>
        <div className={styles.initialFeeContainer}>
          <TextInput
            type="text"
            label="Monthly package fee"
            name="monthlyRate"
            value={monthlyRate}
            onChange={handleFormChange}
          />
          <TextInput
            type="text"
            label="Discount applied"
            value={discount}
            onChange={e => handleDiscountChange(e, monthlyRate, setPaymentPeriodData)}
          />
        </div>
        <Toggle
          label="Enable premium support"
          name="hasPremiumSupport"
          handleChange={() =>
            setPaymentPeriodData({ hasPremiumSupport: !hasPremiumSupport })
          }
          checked={hasPremiumSupport}
        />
        <TextInput
          type="text"
          label="Monthly premium support fee"
          name="premiumSupportFee"
          value={premiumSupportFee}
          onChange={handleFormChange}
          disabled={!hasPremiumSupport}
        />
      </div>
    </ConfirmationDialog>
  )
}

export default EditPaymentPeriodDialog
